module.exports = __webpack_public_path__ + "img/2.6_About-Us_Key-Partner_12_CAPR.6fab42d5ab4a86c959055571198aab5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_About-Us_Key-Partner_12_CAPR.png
// module id = 774
// module chunks = 0